import { render, staticRenderFns } from "./boutiqueMall.vue?vue&type=template&id=a3c46dfc&scoped=true&"
import script from "./boutiqueMall.vue?vue&type=script&lang=js&"
export * from "./boutiqueMall.vue?vue&type=script&lang=js&"
import style0 from "./boutiqueMall.vue?vue&type=style&index=0&id=a3c46dfc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c46dfc",
  null
  
)

export default component.exports